export default __webpack_public_path__ + "static/media/MarginImpactCluster.277dde9b.png";